/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-console */
import { Injectable } from '@angular/core';
import { TableInfoRepository, WorkspaceRepository } from '@database/central';
import { DatabaseManagerService, RefTablesStorageService } from '@database/workspace';
import { ErrorCodes, LoadingIndicatorState } from '@shared';
import { LoggingService } from '@shared/logging';

@Injectable()
export class DeleteWorkfileService {
	public constructor(
		private loadingIndicator: LoadingIndicatorState,
		private refTablesStorageService: RefTablesStorageService,
		private tableInfoRepository: TableInfoRepository,
		private workspaceRepository: WorkspaceRepository,
		private loggingService: LoggingService,
		private databaseManagerService: DatabaseManagerService
	) {}

	public async delete(workfileId: string): Promise<void> {
		this.loadingIndicator.setIsLoading(true);
    
    	this.workspaceRepository.deleteWorkfile(workfileId)
        .then(() => this.workspaceRepository.setWorfileDeleteStatus(workfileId))
        .then(() => Promise.all([
            this.tableInfoRepository.deleteRecords(workfileId),
            this.databaseManagerService.deleteWorkfile(workfileId),
            this.refTablesStorageService.deleteRecords(workfileId),
            this.refTablesStorageService.deleteLastRxdbIdRecord(workfileId)
        ]))
        .catch(error => {
            console.error('error', error);
            this.loggingService.error(ErrorCodes.DeleteWorkfileError, error);
            throw error;
        })
        .finally(() => {
            this.loadingIndicator.setIsLoading(false);
        });
	}
}
